import { FC, Fragment } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// i18next
import { useTranslation } from 'react-i18next';
// Components
import { Input } from 'app/components/Mui';
import Phone from 'app/components/Phone';
import PasswordHints from 'app/components/PasswordHints';
// Utilities
import {
  isDigit, isEmailValid, isLowerCase, isMinLength,
  isRequired, isSpecialCharacter, isUpperCase
} from 'app/utilities/Validations';

const AccountStep:FC = () => {
  const { t } = useTranslation();

  const { control, formState: { errors }, watch } = useFormContext();

  const watchPassword = watch('password');

  return (
    <Fragment>
      <Controller
        name="name"
        control={control}
        rules={{ required: isRequired }}
        render={({ field }) => (
          <Input
            {...field}
            label={t('labels.name')}
            required
            error={Boolean(errors.name)}
            helperText={(errors.name as any)?.message || ''}
          />
        )}
      />
      <Controller
        name="email"
        control={control}
        rules={{ required: isRequired, pattern: isEmailValid }}
        render={({ field }) => (
          <Input
            {...field}
            type="email"
            label={t('labels.email')}
            required
            error={Boolean(errors.email)}
            helperText={(errors.email as any)?.message || ''}
          />
        )}
      />
      <Controller
        name="phone"
        control={control}
        rules={{ required: isRequired }}
        render={({ field }) => (
          <Phone
            {...field}
            label={t('labels.cellPhone')}
            required={true}
            error={Boolean(errors.phone)}
            helperText={(errors.phone as any)?.message || ''}
          />
        )}
      />
      <Controller
        name="company"
        control={control}
        rules={{ required: isRequired }}
        render={({ field }) => (
          <Input
            {...field}
            label={t('labels.companyName')}
            required
            error={Boolean(errors.company)}
            helperText={(errors.company as any)?.message || ''}
          />
        )}
      />
      <Controller
        name="password"
        control={control}
        rules={{
          required: isRequired,
          minLength: isMinLength(8),
          validate: {
            isLowerCase,
            isUpperCase,
            isSpecialCharacter,
            isDigit
          }
        }}
        render={({ field }) => (
          <Input
            {...field}
            type="password"
            label={t('labels.password')}
            required
            error={Boolean(errors.password)}
            helperText={(errors.password as any)?.message || ''}
          />
        )}
      />
      <Controller
        control={control} name="rePassword"
        rules={{
          required: isRequired,
          validate: (value:string) => value === watchPassword || t('validations.passwordDoesntMatch')
        }}
        render={({ field }) => (
          <Input
            {...field}
            label={t('labels.confirmPassword')} type="password" autoComplete="off"
            required
            error={Boolean(errors.rePassword)}
            helperText={(errors.rePassword as any)?.message || ''}
          />
        )}
      />

      <PasswordHints />
    </Fragment>
  )
}

export default AccountStep;
